'use client';
import React, {ReactNode} from 'react';
import { Tooltip } from 'react-tooltip';
import HelpIcon from '../Icons/Help';

const CINTooltip = () => {
  return (
    <>
      <Tooltip
        id="cin-tooltip"
        place="top">
        <p>Codice Identificativo Nazionale</p>
      </Tooltip>
      <HelpIcon
        id="cin-tooltip"
        className="w-5 h-5 fill-current text-gray-300"
        />
      </>
    )
};

export default CINTooltip;
